import React, { Component } from "react"
import moment from "moment"
import { getIconNotifications } from '../../utils/functions'
import Tooltip from "../Tooltip"

export default class NotificacaoItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMounted: true
    }
  }

  componentWillUnmount() {
    this.setState({ isMounted: false })
  }

  onChangeRead = async idHistory => {
    if (!this.state.isMounted) return;
    const idProfile = localStorage.getItem("idProfile")
    console.log(idHistory, idProfile)
  }

  render() {
    const { item, first } = this.props
    return (
      <div className={`notificacao-notificacoes ${!first && "notFirstChild"}`}>
        <Tooltip />
        <div className=" d-flex align-items-center icon-notificacao">
          <i className={getIconNotifications(item.tipoEnvio)} aria-hidden="true" />
        </div>
        <div className="col no-gutters  d-flex align-items-center description-notificacao">
          <label data-tip={item.descricao} className="text-notification">
            {item.texto}
          </label>
        </div>
        <div className="d-flex justify-content-end align-items-center date-notificacao">
          <label>
            <strong style={{ whiteSpace: "nowrap" }}>{moment(item.dataExecucao).toNow()}</strong>
          </label>
        </div>
        <div
          className="d-flex justify-content-end align-items-center date-notificacao"
          style={{ padding: "0 5px" }}
        >
          {item.readMessage ? (
            <label className="cursor-pointer">
              <i className="fa fa-circle-thin" aria-hidden="true" />
            </label>
          ) : (
            <button
              type="button"
              data-tip="Marcar como lida"
              onClick={() => this.onChangeRead(item.idHistory)}
              className="mark-read"
              style={{ background: 'none', border: 'none', padding: 0 }}
            >
              <i className="fa fa-circle" aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    )
  }
}
